import { useTranslation } from 'react-i18next';

export interface SafeErrorStateProps {
  /** Reintenta las consultas fallidas sin recargar la página. */
  onRetry: () => void;
  /** Deshabilita el botón mientras el reintento está en vuelo. */
  isRetrying?: boolean;
}

/**
 * Mensaje mostrado cuando el dashboard no pudo cargar por un fallo del servicio.
 * Es deliberadamente distinto del estado vacío: antes ambos casos terminaban en la
 * misma pantalla y una caída se leía como falta de retroalimentación.
 */
export function SafeErrorState({ onRetry, isRetrying = false }: SafeErrorStateProps) {
  const { t } = useTranslation();

  return (
    <div className="ud-wrap">
      <div className="ud-error-state" role="alert">
        <div className="ud-error-icon" aria-hidden="true">
          <i className="fas fa-triangle-exclamation" />
        </div>
        <h2 className="ud-error-title">{t('safe.error.title')}</h2>
        <p className="ud-error-desc">{t('safe.error.desc')}</p>
        <button
          type="button"
          className="ud-error-retry"
          onClick={onRetry}
          disabled={isRetrying}
        >
          <i className="fas fa-rotate-right" aria-hidden="true" />
          {isRetrying ? t('safe.error.retrying') : t('safe.error.retry')}
        </button>
      </div>
    </div>
  );
}
